const MONTHS = ["", "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

export function indianGroup(n) {
  const s = String(n);
  if (s.length <= 3) return s;
  const last3 = s.slice(-3);
  let rest = s.slice(0, -3);
  const parts = [];
  while (rest.length > 2) {
    parts.unshift(rest.slice(-2));
    rest = rest.slice(0, -2);
  }
  if (rest) parts.unshift(rest);
  return parts.join(",") + "," + last3;
}

export function formatINR(paise, withSymbol = true) {
  if (paise == null || isNaN(paise)) return withSymbol ? "\u20b90" : "0";
  const neg = paise < 0;
  paise = Math.abs(Math.round(paise));
  const rupees = Math.floor(paise / 100);
  const p = paise % 100;
  let body = indianGroup(rupees);
  if (p) body += "." + String(p).padStart(2, "0");
  return `${neg ? "-" : ""}${withSymbol ? "\u20b9" : ""}${body}`;
}

export function rupeesToPaise(r) {
  return Math.round(parseFloat(r || 0) * 100);
}

export function paiseToRupees(p) {
  return (p || 0) / 100;
}

export function monthName(m) {
  return MONTHS[m] || "";
}

export const MONTH_OPTIONS = MONTHS.slice(1).map((name, i) => ({ value: i + 1, label: name }));

export function currentFYYears() {
  // returns array of years relevant to current + previous FY
  const now = new Date();
  const y = now.getFullYear();
  return [y - 2, y - 1, y, y + 1];
}

export function fmtDate(d) {
  if (!d) return "\u2014";
  try {
    const dt = new Date(String(d).slice(0, 10));
    return dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return String(d);
  }
}
